 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		228: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"f83f697","1":"20fe5e7","2":"0ca8dba","3":"8fe840c","4":"0ee3a15","5":"6e9aa7d","6":"fca656b","7":"eea1076","8":"5e1a542","9":"fecf196","10":"83aea83","11":"e3c33e2","12":"197a510","13":"d7493d1","14":"deb5d78","15":"2ae792d","16":"b361bbd","17":"2483de1","18":"02acde8","19":"3eb3cbe","20":"54ab9a5","21":"583b09b","22":"e268ecb","23":"1b8f24c","24":"48c970a","25":"fe7e8ea","26":"82e2150","27":"065c84e","28":"16cedb5","29":"cfb73e6","30":"b71f1de","31":"13d2f51","32":"182e849","33":"c8aed6b","34":"3475e66","35":"c332de4","36":"682948f","37":"6d92d67","38":"440aaaa","39":"567450e","40":"78bab1c","41":"210a110","42":"522028d","43":"dd5c556","44":"adc4bcd","45":"8cdbe81","46":"4838b17","47":"70dc4ff","48":"2ff28fc","49":"203e316","50":"48ad76a","51":"05be48f","52":"95073de","53":"c586d70","54":"2f13844","55":"13a74d8","56":"db0a3df","57":"66ba0f9","58":"837ab16","59":"2d3817d","60":"dcd5649","61":"1243e02","62":"53e61a2","63":"1df82bd","64":"b14923b","65":"78d075f","66":"20a2749","67":"2ca72d9","68":"15d6681","69":"d0abfd4","70":"012ea4b","71":"14621f9","72":"96d4bc6","73":"dc2c328","74":"54d2d72","75":"e81c884","76":"ef155e7","77":"8e0c8ad","78":"8b54008","79":"f56877e","80":"ea65ee3","81":"e248b07","82":"31ae46e","83":"e5577f9","84":"0a357bf","85":"582f9af","86":"bbb2acb","87":"c97285b","88":"1b68e9b","89":"6312ea6","90":"d86edc4","91":"953a82a","92":"5cfa06e","93":"4a8bf36","94":"7552729","95":"3453bd3","96":"1426a26","97":"fcaf7eb","98":"6e5ee72","99":"eed05cd","100":"4c4ba80","101":"f95d87b","102":"057f907","103":"fc8c411","104":"4590281","105":"a4d2f26","106":"04bbd6b","107":"a57281e","108":"2057517","109":"99a7a0b","110":"4f74d90","111":"766b01b","114":"f523051","115":"89d3607","116":"b79aa3d","117":"d47e744","118":"aea90df","119":"cd8d442","120":"f9f6839","121":"c4d7e36","122":"e0d0aa4","123":"5a90700","124":"f4297f4","125":"8e4de51","126":"8e962bc","127":"c6a1f89","128":"c17ab0b","129":"5ca6e15","130":"f405fca","131":"e843c0f","132":"8f63c2c","133":"2b1bb96","134":"a265255","135":"4577a58","136":"558434b","137":"7fd8f80","138":"16fd920","139":"e97fb28","140":"82e774e","141":"7e746f5","142":"8f55153","143":"ae6b155","144":"2e9f28e","145":"edffc34","146":"75fe4f5","147":"cda3cb5","148":"bb32c53","149":"fd801b7","150":"31b24ab","151":"8700d5b","152":"728326a","153":"5294ade","154":"e43619a","155":"5382fec","156":"c592694","157":"8b31273","158":"5e0e403","159":"f86dac9","160":"069d456","161":"3f628f2","162":"f1e7bc1","163":"038bfbe","164":"5971e94","165":"26c2bf4","166":"618b8d2","167":"a9dc975","168":"3b647a9","169":"b2923f5","170":"b6d80c5","171":"ddfacb6","172":"2cd8fee","173":"7511feb","174":"03b8737","175":"d3707e4","176":"dd67847","177":"b33ea2d","178":"3a69d19","179":"3225523","180":"d034f39","181":"d7ce710","182":"4169ce4","183":"ba44828","184":"dd84b2f","185":"f467084","186":"51f2558","187":"e6de103","188":"16e95ec","189":"0882cfa","190":"4bb5626","191":"f04f72b","192":"0483765","193":"c4382f5","194":"ab3b987","195":"44abf75","196":"674e87f","197":"b9bf9a6","198":"4140674","199":"98b33a5","200":"8535dd7","201":"27974c2","202":"c63f42c","203":"2b57c48","204":"7db1dd5","205":"8443f31","206":"6f01a53","207":"fed8f2d","208":"04d0a50","209":"80dc4a8","210":"ae4c851","211":"f36767c","212":"c8ebfee","213":"afc9a21","214":"a587280","215":"44f8eb3","216":"62bbb99","217":"9b5e561","218":"84b85a5","219":"2e62d4a","220":"247763a","221":"17f5a60","222":"ae8e72d","223":"c3c4d90","224":"09f785b","225":"c4e7479","226":"067d9f6","227":"fdb6ad8","230":"e1d92ae","231":"cb961ed","232":"d78bb88","233":"ae68c2d","234":"bcaf6a2","235":"2b62b24","236":"8b9b138","237":"4ea7d20","238":"7dba4bf","239":"2dbaa42","240":"96627e8","241":"28bd1ff","242":"111aab0","243":"415949b","244":"1337569","245":"70c2050","246":"623b2e0","247":"0d0c6eb","248":"6864acb","249":"5b12aa3","250":"2101fe7","251":"4c840e5","252":"6fb0cca","253":"c5e83e2","254":"cba7b0f","255":"1e19d73","256":"efa6887","257":"b1033bc","258":"2a9e58a","259":"ba33828","260":"4278422","261":"6a5b323","262":"e05574b","263":"4785bc4","264":"67d61c7","265":"91c62db","266":"691172d","267":"2ae8358","268":"cd0d156","269":"86cd6d9","270":"edd2e1e","271":"9ea3eed","272":"572392c","273":"894bc52","274":"7d50ee4","275":"16e326a","276":"d506610","277":"2d47b5a","278":"d958798","279":"1146b97","280":"76b2c83","281":"9d827b3","282":"10eff68","283":"e9d1250","284":"9050f78","285":"ae2506c","286":"4bc1446","287":"a25af58","288":"30de0ef","289":"7ca1b83","290":"fe9484c","291":"e5bf9d7","292":"8d09666","293":"21c9653","294":"007a51d","295":"7852fc1","296":"7f9f5fe","297":"2d33397","298":"7657343","299":"5a1a8cf","300":"7d395d9","301":"124ba08","302":"35f7952","303":"8258b08","304":"5fc74f7","305":"a715040","306":"b8b998d","307":"d4f0e07","308":"77e42bb","309":"8ca819b","310":"f77d584","311":"1a95542","312":"7982411","313":"07ea637","314":"09f7e95","315":"9a52bd1","316":"042cebb","317":"579351e","318":"34facc9","319":"5dafa69","320":"bcf7870","321":"635561c","322":"419724f","323":"3dfa1e3","324":"6aa7222","325":"157433a","326":"ca460ac","327":"c0accc2","328":"1bf6d38","329":"6affb4d","330":"b3d11b0","331":"6b50e2d","332":"fb325c4","333":"571a31a","334":"81dc282","335":"bdf2f6b","336":"421cbd2","337":"9367f8f","338":"0f14be2","339":"f789c57","340":"58888d3","341":"1995fc8","342":"79021c2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
